import {
  OrderCargoOrderHistoryItemAddCargoEnterChangeRideCommand,
  OrderCargoOrderHistoryItemAddCargoExitChangeRideCommand,
  OrderCargoOrderHistoryItemChangeHaltingTimeChangeRideCommand,
  OrderCargoOrderHistoryItemChangePositionChangeRideCommand,
  OrderCargoOrderHistoryItemChangeRideCommandUpdateRideCommand,
  OrderCargoOrderHistoryItemChangeTimeChangeRideCommand,
  OrderCargoOrderHistoryItemCreateInnerRideChangeRideCommand,
  OrderCargoOrderHistoryItemDeleteNodeChangeRideCommand,
  OrderCargoOrderHistoryItemDoNothingChangeRideCommand,
  OrderCargoOrderHistoryItemInsertNodeAfterChangeRideCommand,
  OrderCargoOrderHistoryItemInsertNodeBeforeChangeRideCommand,
  OrderCargoOrderHistoryItemRemoveCargoEnterChangeRideCommand,
  OrderCargoOrderHistoryItemRemoveCargoExitChangeRideCommand,
  OrderCargoOrderHistoryItemSquashInnerRideChangeRideCommand,
  OrderCargoOrderHistoryChangeRideEventType,
} from "../../../../../common/services/order/cargo-order/history/order-cargo-order-history";
import OrderDetailsHistoryEntryChangeRideInternalEvent, {
  OrderDetailsHistoryEntryAddCargoEnterChangeRideEvent,
  OrderDetailsHistoryEntryAddCargoExitChangeRideEvent,
  OrderDetailsHistoryEntryChangeHaltingTimeChangeRideEvent,
  OrderDetailsHistoryEntryChangePositionChangeRideEvent,
  OrderDetailsHistoryEntryChangeTimeChangeRideEvent,
  OrderDetailsHistoryEntryCreateInnerRideChangeRideEvent,
  OrderDetailsHistoryEntryDeleteNodeChangeRideEvent,
  OrderDetailsHistoryEntryDoNothingChangeRideEvent,
  OrderDetailsHistoryEntryInsertNodeAfterChangeRideEvent,
  OrderDetailsHistoryEntryInsertNodeBeforeChangeRideEvent,
  OrderDetailsHistoryEntryRemoveCargoEnterChangeRideEvent,
  OrderDetailsHistoryEntryRemoveCargoExitChangeRideEvent,
  OrderDetailsHistoryEntrySquashInnerRideChangeRideEvent,
} from "./types/order-details-history-change-ride-event";
import OrderDetailsHistoryChangeRideEventType from "./types/order-details-history-change-ride-event-type";

const createAddCargoEnterEvent = (
  responseItemAddCargoEnterChangeRideCommand: OrderCargoOrderHistoryItemAddCargoEnterChangeRideCommand,
): OrderDetailsHistoryEntryAddCargoEnterChangeRideEvent => {
  return {
    type: OrderDetailsHistoryChangeRideEventType.ADD_CARGO_ENTER,
  };
};

const createAddCargoExitEvent = (
  responseItemAddCargoExitChangeRideCommand: OrderCargoOrderHistoryItemAddCargoExitChangeRideCommand,
): OrderDetailsHistoryEntryAddCargoExitChangeRideEvent => {
  return {
    type: OrderDetailsHistoryChangeRideEventType.ADD_CARGO_EXIT,
  };
};

const createChangeHaltingTimeEvent = (
  responseItemChangeHaltingTimeChangeRideCommand: OrderCargoOrderHistoryItemChangeHaltingTimeChangeRideCommand,
): OrderDetailsHistoryEntryChangeHaltingTimeChangeRideEvent => {
  return {
    type: OrderDetailsHistoryChangeRideEventType.CHANGE_HALTING_TIME,
    details: {
      newHaltingTime:
        responseItemChangeHaltingTimeChangeRideCommand.haltingTime,
    },
  };
};

const createChangePositionEvent = (
  responseItemChangePositionChangeRideCommand: OrderCargoOrderHistoryItemChangePositionChangeRideCommand,
): OrderDetailsHistoryEntryChangePositionChangeRideEvent => {
  return {
    type: OrderDetailsHistoryChangeRideEventType.CHANGE_POSITION,
    details: {
      newPlaceAddressDisplayName:
        responseItemChangePositionChangeRideCommand.displayName,
    },
  };
};

const createChangeTimeEvent = (
  responseItemChangeTimeChangeRideCommand: OrderCargoOrderHistoryItemChangeTimeChangeRideCommand,
): OrderDetailsHistoryEntryChangeTimeChangeRideEvent => {
  return {
    type: OrderDetailsHistoryChangeRideEventType.CHANGE_TIME,
    details: {
      newPlannedDate: responseItemChangeTimeChangeRideCommand.time
        ? new Date(responseItemChangeTimeChangeRideCommand.time)
        : null,
    },
  };
};

const createCreateInnerRideEvent = (
  responseItemCreateInnerRideChangeRideCommand: OrderCargoOrderHistoryItemCreateInnerRideChangeRideCommand,
): OrderDetailsHistoryEntryCreateInnerRideChangeRideEvent => {
  return {
    type: OrderDetailsHistoryChangeRideEventType.CREATE_INNER_RIDE,
  };
};

const createDeleteNodeEvent = (
  responseItemDeleteNodeChangeRideCommand: OrderCargoOrderHistoryItemDeleteNodeChangeRideCommand,
): OrderDetailsHistoryEntryDeleteNodeChangeRideEvent => {
  return {
    type: OrderDetailsHistoryChangeRideEventType.DELETE_NODE,
  };
};

const createDoNothingEvent = (
  responseItemDoNothingChangeRideCommand: OrderCargoOrderHistoryItemDoNothingChangeRideCommand,
): OrderDetailsHistoryEntryDoNothingChangeRideEvent => {
  return {
    type: OrderDetailsHistoryChangeRideEventType.DO_NOTHING,
  };
};

const createInsertNodeAfterEvent = (
  responseItemInsertNodeAfterChangeRideCommand: OrderCargoOrderHistoryItemInsertNodeAfterChangeRideCommand,
): OrderDetailsHistoryEntryInsertNodeAfterChangeRideEvent => {
  return {
    type: OrderDetailsHistoryChangeRideEventType.INSERT_NODE_AFTER,
    details: {
      haltingTime:
        responseItemInsertNodeAfterChangeRideCommand.subject.haltingTime,
      placeAddressDisplayName:
        responseItemInsertNodeAfterChangeRideCommand.subject.displayName,
      date: responseItemInsertNodeAfterChangeRideCommand.subject.time
        ? new Date(responseItemInsertNodeAfterChangeRideCommand.subject.time)
        : null,
    },
  };
};

const createInsertNodeBeforeEvent = (
  responseItemInsertNodeBeforeChangeRideCommand: OrderCargoOrderHistoryItemInsertNodeBeforeChangeRideCommand,
): OrderDetailsHistoryEntryInsertNodeBeforeChangeRideEvent => {
  return {
    type: OrderDetailsHistoryChangeRideEventType.INSERT_NODE_BEFORE,
    details: {
      haltingTime:
        responseItemInsertNodeBeforeChangeRideCommand.subject.haltingTime,
      placeAddressDisplayName:
        responseItemInsertNodeBeforeChangeRideCommand.subject.displayName,
      date: responseItemInsertNodeBeforeChangeRideCommand.subject.time
        ? new Date(responseItemInsertNodeBeforeChangeRideCommand.subject.time)
        : null,
    },
  };
};

const createRemoveCargoEnterEvent = (
  responseItemRemoveCargoEnterChangeRideCommand: OrderCargoOrderHistoryItemRemoveCargoEnterChangeRideCommand,
): OrderDetailsHistoryEntryRemoveCargoEnterChangeRideEvent => {
  return {
    type: OrderDetailsHistoryChangeRideEventType.REMOVE_CARGO_ENTER,
  };
};

const createRemoveCargoExitEvent = (
  responseItemRemoveCargoExitChangeRideCommand: OrderCargoOrderHistoryItemRemoveCargoExitChangeRideCommand,
): OrderDetailsHistoryEntryRemoveCargoExitChangeRideEvent => {
  return {
    type: OrderDetailsHistoryChangeRideEventType.REMOVE_CARGO_EXIT,
  };
};

const createSquashInnerRideEvent = (
  responseItemSquashInnerRideChangeRideCommand: OrderCargoOrderHistoryItemSquashInnerRideChangeRideCommand,
): OrderDetailsHistoryEntrySquashInnerRideChangeRideEvent => {
  return {
    type: OrderDetailsHistoryChangeRideEventType.SQUASH_INNER_RIDE,
  };
};

const createEvent = (
  responseItemChangeRideCommandUpdateRideCommand: OrderCargoOrderHistoryItemChangeRideCommandUpdateRideCommand,
): OrderDetailsHistoryEntryChangeRideInternalEvent => {
  switch (responseItemChangeRideCommandUpdateRideCommand.commandType) {
    case OrderCargoOrderHistoryChangeRideEventType.ADD_CARGO_ENTER:
      return createAddCargoEnterEvent(
        responseItemChangeRideCommandUpdateRideCommand as OrderCargoOrderHistoryItemAddCargoEnterChangeRideCommand,
      );
    case OrderCargoOrderHistoryChangeRideEventType.ADD_CARGO_EXIT:
      return createAddCargoExitEvent(
        responseItemChangeRideCommandUpdateRideCommand as OrderCargoOrderHistoryItemAddCargoExitChangeRideCommand,
      );
    case OrderCargoOrderHistoryChangeRideEventType.CHANGE_HALTING_TIME:
      return createChangeHaltingTimeEvent(
        responseItemChangeRideCommandUpdateRideCommand as OrderCargoOrderHistoryItemChangeHaltingTimeChangeRideCommand,
      );
    case OrderCargoOrderHistoryChangeRideEventType.CHANGE_POSITION:
      return createChangePositionEvent(
        responseItemChangeRideCommandUpdateRideCommand as OrderCargoOrderHistoryItemChangePositionChangeRideCommand,
      );
    case OrderCargoOrderHistoryChangeRideEventType.CHANGE_TIME:
      return createChangeTimeEvent(
        responseItemChangeRideCommandUpdateRideCommand as OrderCargoOrderHistoryItemChangeTimeChangeRideCommand,
      );
    case OrderCargoOrderHistoryChangeRideEventType.CREATE_INNER_RIDE:
      return createCreateInnerRideEvent(
        responseItemChangeRideCommandUpdateRideCommand as OrderCargoOrderHistoryItemCreateInnerRideChangeRideCommand,
      );
    case OrderCargoOrderHistoryChangeRideEventType.DELETE_NODE:
      return createDeleteNodeEvent(
        responseItemChangeRideCommandUpdateRideCommand as OrderCargoOrderHistoryItemDeleteNodeChangeRideCommand,
      );
    case OrderCargoOrderHistoryChangeRideEventType.DO_NOTHING:
      return createDoNothingEvent(
        responseItemChangeRideCommandUpdateRideCommand as OrderCargoOrderHistoryItemDoNothingChangeRideCommand,
      );
    case OrderCargoOrderHistoryChangeRideEventType.INSERT_NODE_AFTER:
      return createInsertNodeAfterEvent(
        responseItemChangeRideCommandUpdateRideCommand as OrderCargoOrderHistoryItemInsertNodeAfterChangeRideCommand,
      );
    case OrderCargoOrderHistoryChangeRideEventType.INSERT_NODE_BEFORE:
      return createInsertNodeBeforeEvent(
        responseItemChangeRideCommandUpdateRideCommand as OrderCargoOrderHistoryItemInsertNodeBeforeChangeRideCommand,
      );
    case OrderCargoOrderHistoryChangeRideEventType.REMOVE_CARGO_ENTER:
      return createRemoveCargoEnterEvent(
        responseItemChangeRideCommandUpdateRideCommand as OrderCargoOrderHistoryItemRemoveCargoEnterChangeRideCommand,
      );
    case OrderCargoOrderHistoryChangeRideEventType.REMOVE_CARGO_EXIT:
      return createRemoveCargoExitEvent(
        responseItemChangeRideCommandUpdateRideCommand as OrderCargoOrderHistoryItemRemoveCargoExitChangeRideCommand,
      );
    case OrderCargoOrderHistoryChangeRideEventType.SQUASH_INNER_RIDE:
      return createSquashInnerRideEvent(
        responseItemChangeRideCommandUpdateRideCommand as OrderCargoOrderHistoryItemSquashInnerRideChangeRideCommand,
      );
  }
};

const createEvents = (
  responseItemChangeRideCommandUpdateRideCommands: OrderCargoOrderHistoryItemChangeRideCommandUpdateRideCommand[],
): OrderDetailsHistoryEntryChangeRideInternalEvent[] => {
  return responseItemChangeRideCommandUpdateRideCommands.map(createEvent);
};

const orderDetailsHistoryChangeRideEntryFactory = {
  createEvents,
};

export default orderDetailsHistoryChangeRideEntryFactory;
